import React, {useState} from 'react';
// import { Button, Image, TouchableOpacity } from 'react-native';
// import { DrawerActions } from '@react-navigation/native';
// import { color } from 'react-native-reanimated';
// import * as Drawers from '../navigation/DrawerNavigation';

export const colorPalette = {
  mainColor: '#E12F4F',
  White: '#FFFFFF',
  Dark: '#555555',
}

export const menuProfilePic = {
  headerRightProfileIconButton: {height: 40, width:40, marginRight:10, borderRadius:400/2}
}

export const loginScreen ={
  footer: {backgroundColor: colorPalette.White}
}

// function StackNavigationHeader({ navigation }) {
//   return(
//       React.useLayoutEffect(() => {
//         navigation.setOptions({
//           headerLeft: () => (
//             <TouchableOpacity onPress={() => navigation.dispatch(DrawerActions.toggleDrawer())}>
//               <Image
//                 source={require('../assets/ionic-ios-menu.png')}
//                 style={ layoutFormat.headerLeftMenuButton }
//               />
//             </TouchableOpacity>
//           ),
//           headerRight: () => (
//             // TODO - update to pull profile photo from database
//             <TouchableOpacity onPress={() => navigation.dispatch(DrawerActions.toggleDrawer())}>
//               <Image
//                 source={require('../assets/profilePicTesting/Hans.png')}
//                 style={ layoutFormat.headerRightProfileIconButton }
//               />
//             </TouchableOpacity>
//           ),
//           headerStyle: {
//             backgroundColor: colorPalette.mainColor,            
//           },
//           headerTintColor: colorPalette.Whilte,
//         });
//       }, [navigation])
//   )
// }


//export default { colorPalette, menuProfilePic } 